// extracted by mini-css-extract-plugin
export default {"infotop":"AmpInfoWrapper_infotop__cHIuN","icon":"AmpInfoWrapper_icon__OKkqW","info":"AmpInfoWrapper_info__t68F6"};